// extracted by mini-css-extract-plugin
export default {"tw":"tw"};